<template>
	<b-modal
		ref="confrontation-drafts-list-modal"
		size="xmd"
		:title="`LISTA DE TOPES`"
		hide-footer
		@hidden="handleCloseModal"
		scrollable
		style="z-index: 80000"
		no-close-on-backdrop
		no-close-on-esc
	>
		<template #modal-header>
			<div class="d-flex justify-content-between align-items-center w-100">
				<div class="font-weight-bold">Topes Múltiples</div>
				<div style="display: flex; gap: 0.5rem">
					<b-button
						:disabled="drafts.some((draft) => draft.isUploading)"
						variant="danger"
						@click="handleCloseModal"
						v-b-tooltip.hover="'Cerrar'"
					>
						<FeatherIcon icon="XIcon" />
					</b-button>
				</div>
			</div>
		</template>
		<b-alert variant="warning" :show="drafts.some((draft) => draft.isUploading)" class="p-2">
			<FeatherIcon icon="AlertTriangleIcon" class="mr-1" />
			No cerrar ventana hasta que se hayan subido todos los videos de los topes.
		</b-alert>
		<b-overlay :show="isLoading">
			<b-row class="mb-1">
				<b-col class="d-flex align-items-center">
					<small class="text-secondary">
						Mostrando {{ pagination.from }} a {{ pagination.to }} de {{ pagination.total }} registros
					</small>
				</b-col>
				<b-col class="d-flex align-items-center justify-content-end flex-wrap gap-x-4 gap-y-1">
					<b-pagination
						v-model="pagination.curPage"
						:total-rows="pagination.total"
						:per-page="pagination.perPage"
						first-number
						last-number
						class="mb-0 mt-1 mt-sm-0"
						prev-class="prev-item"
						next-class="next-item"
					>
						<template #prev-text>
							<feather-icon icon="ChevronLeftIcon" size="18" />
						</template>
						<template #next-text>
							<feather-icon icon="ChevronRightIcon" size="18" />
						</template>
					</b-pagination>
				</b-col>
			</b-row>
			<b-row class="mb-1">
				<b-col cols="12" xl="7" class="d-flex align-items-center justify-content-start mt-1 mb-md-0">
					<label>Mostrar</label>
					<v-select
						v-model="pagination.perPage"
						:options="perPageOptions"
						:clearable="false"
						class="per-page-selector d-inline-block mx-50"
						style="width: 90px"
					/>
					<label class="mr-2">registros</label>
					<feather-icon class="cursor-pointer" icon="RefreshCcwIcon" size="20" @click="refresh" />
				</b-col>
				<b-col cols="12" xl="5">
					<div class="container-btns-page-specimens">
						<div class="d-flex">
							<b-input-group id="cintillo-ala-input-group">
								<b-form-input
									v-model="search"
									class="d-inline-block"
									placeholder="Buscar ejemplar"
									@keyup.enter="handleInputSearch"
									debounce="500"
								/>
								<b-input-group-append>
									<b-button variant="outline-primary" @click="handleInputSearch()">
										<feather-icon class="cursor-pointer" icon="SearchIcon" />
									</b-button>
								</b-input-group-append>
							</b-input-group>
						</div>
					</div>
				</b-col>
			</b-row>
			<b-table-simple responsive sticky-header="60vh" no-border-collapse>
				<b-thead class="sticky-header" style="white-space: nowrap">
					<b-tr>
						<b-th v-for="field in fields" :key="field.key" :class="field.class">
							{{ field.label }}
							<v-icon
								v-if="field.key === 'local' || field.key === 'rival'"
								name="gi-boxing-glove"
								scale="1.3"
								class="ml-1"
								:class="field.key === 'local' ? 'text-danger' : 'glove-blue'"
								style="transform: rotate(270deg); color: blue"
							/>
						</b-th>
					</b-tr>
				</b-thead>
				<b-tbody>
					<template v-if="drafts.length > 0">
						<b-tr v-for="(draft, index) in drafts" :key="index">
							<b-td class="text-center">
								{{ draft.order }}
							</b-td>
							<b-td class="text-center">
								{{ draft.type }}
							</b-td>
							<b-td class="text-center">
								<SpecimenPlate
									v-if="draft.local"
									:specimen="draft.local"
									show_status
									show_details_icon
								/>
							</b-td>
							<b-td class="text-center">
								<SpecimenPlate
									v-if="draft.type_id === 1"
									:specimen="draft.rival"
									show_status
									show_details_icon
								/>
								<span v-else>{{ draft.rival.name }}</span>
							</b-td>
							<b-td class="text-center">
								{{ draft.created_at | myGlobalDayShort }}
							</b-td>
							<b-td class="text-center">
								<template v-if="!draft.isReady && !draft.isUploading">
									<b-button
										variant="flat-primary"
										size="sm"
										@click="openModalAddVideoBySpecimen(draft)"
									>
										<feather-icon icon="PlusIcon" size="16" />
									</b-button>
									<b-button variant="flat-danger" size="sm" @click="deleteDraft(draft.id)">
										<feather-icon icon="TrashIcon" size="16" />
									</b-button>
								</template>
								<div v-else-if="draft.isUploading">
									<b-progress :value="draft.value" variant="success" striped animated></b-progress>
								</div>
								<div v-else-if="draft.isReady" class="d-flex align-items-center justify-content-center">
									<feather-icon icon="CheckIcon" size="16" class="text-success mr-1" />
									<span>Listo</span>
								</div>
							</b-td>
						</b-tr>
					</template>
					<b-tr v-if="drafts.length === 0">
						<b-td :colspan="fields.length" class="text-center">No hay registros para mostrar</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</b-overlay>
		<b-modal hide-footer v-model="modalAddVideoBySpecimen" size="xmd" no-close-on-backdrop hide-header centered>
			<UploadTopeVideo
				@resetTable="refreshUploadModal"
				@close="modalAddVideoBySpecimen = false"
				:specimen_to_update_id="null"
				:draft="selectedDraft"
				@uploadVideo="uploadVideo"
				:title="title"
				:reasons="reasons"
			/>
		</b-modal>
	</b-modal>
</template>

<script>
import ConfrontationDraftsService from "@/views/amg/videolibrary/confrontation-drafts/services/confrontation-drafts.service.js"
import SpecimenPlate from "@/components/specimens/SpecimenPlate.vue"
import UploadTopeVideo from "@/views/amg/videolibrary/confrontation-drafts/components/UploadTopeVideo.vue"
import videosService from "@/services/videos.service"
import TopesReasonsService from "@/views/brain/others/views/topes/services/topesReasons.service.js"
export default {
	name: "ConfrontationDraftsListModal",
	props: {
		selectedGroup: {
			type: Object,
			default: null,
		},
	},
	components: {
		SpecimenPlate,
		UploadTopeVideo,
	},
	data: () => ({
		reasons: [],
		modalAddVideoBySpecimen: false,
		search: "",
		isLoading: false,
		fields: [
			{ key: "order", label: "#", class: "text-center" },
			{ key: "type", label: "TIPO", class: "text-center" },
			{ key: "local", label: "EJEMPLAR #1", class: "text-center" },
			{ key: "rival", label: "EJEMPLAR #2", class: "text-center" },
			{
				key: "date",
				label: "FECHA",
				class: "text-center",
			},
			{ key: "action", label: "ACCIÓN", class: "text-center" },
		],
		perPageOptions: [10, 25, 50],
		pagination: {
			total: 0,
			curPage: 1,
			perPage: 25,
			from: 0,
			to: 0,
		},
		drafts: [],
		selectedDraft: null,
	}),
	computed: {
		title() {
			if (!this.selectedDraft) return "Subir video de tope"
			return `Subir video de tope | ${this.selectedDraft.local.plate} vs ${
				this.selectedDraft.rival[this.selectedDraft.type_id === 1 ? "plate" : "name"]
			}`
		},
	},
	methods: {
		refreshUploadModal() {
			this.modalAddVideoBySpecimen = false
			this.selectedDraft = null
			// this.$emit("refresh")
			// this.getRows()
		},
		openModalAddVideoBySpecimen(draft) {
			this.selectedDraft = draft
			this.modalAddVideoBySpecimen = true
		},
		refresh() {
			this.getRows()
		},
		handleInputSearch() {
			this.getRows()
		},
		async uploadVideo(toSend) {
			const { fileData, videoForm, id } = toSend
			const chunkSize = 10000000
			let counter = 0
			const totalChunks = Math.ceil(fileData.size / chunkSize)
			this.drafts = this.drafts.map((draft) => {
				if (draft.id === id) {
					return { ...draft, isUploading: true }
				}
				return draft
			})
			try {
				const response = await this.uploadVideoPartitions(fileData, () => {
					counter++
					this.drafts = this.drafts.map((draft) => {
						if (draft.id === id) {
							return { ...draft, value: (counter / totalChunks) * 100 }
						}
						return draft
					})
				})
				if (response.statusResponse == 500) {
					throw new Error()
				}
				videoForm.set("name", response.fileName)
				videoForm.append("path_s3", response.url)
				const config = {
					onUploadProgress: (progressEvent) => {},
				}
				await videosService.saveVideoTope({ videoForm, config })
			} catch (error) {
				this.drafts = this.drafts.map((draft) => {
					if (draft.id === id) {
						return { ...draft, isUploading: false, isReady: false }
					}
					return draft
				})
				this.showToast(
					"danger",
					"top-right",
					"ERROR AL SUBIR VIDEO",
					"AlertCircleIcon",
					"ALGO SALIO MAL, VUELVA A INTENTAR POR FAVOR"
				)
				return
			}
			this.drafts = this.drafts.map((draft) => {
				if (draft.id === id) {
					return { ...draft, isUploading: false, isReady: true }
				}
				return draft
			})
		},
		handleCloseModal() {
			this.$emit("refresh")
			this.$emit("close")
		},
		async getRows(page = 1) {
			try {
				this.isLoading = true
				const { data } = await ConfrontationDraftsService.list({
					per_page: this.pagination.perPage,
					page: page,
					search: this.search,
					group_id: this.selectedGroup.id,
				})
				this.drafts = data.data || []
				this.drafts = this.drafts.map((draft) => {
					return {
						...draft,
						value: 0,
						isUploading: false,
						isReady: false,
					}
				})
				this.pagination.curPage = data.current_page
				this.pagination.total = data.total
				this.pagination.from = data.from
				this.pagination.to = data.to
			} catch (error) {
				console.error("Error fetching average weights report drafts:", error)
			} finally {
				this.isLoading = false
			}
		},
		async deleteDraft(draftId) {
			const { isConfirmed } = await this.showConfirmSwal({
				title: "Eliminar Borrador",
				text: "¿Estás seguro de que deseas eliminar este borrador?",
			})
			if (!isConfirmed) return
			try {
				this.isLoading = true
				await ConfrontationDraftsService.destroy(draftId)
				this.showSuccessToast("Borrador eliminado con éxito")
				await this.getRows()
			} catch (error) {
				console.error("Error deleting draft:", error)
			} finally {
				this.isLoading = false
			}
		},
		async getReasons() {
			try {
				const { data } = await TopesReasonsService.getTopesReasons({
					search: "",
				})
				this.reasons = data.data
			} catch (error) {
				console.log(error)
			}
		},
	},
	watch: {
		"pagination.curPage": async function () {
			await this.getRows(this.pagination.curPage)
		},
		"pagination.perPage": async function () {
			await this.getRows()
		},
	},
	mounted() {
		this.$refs["confrontation-drafts-list-modal"].toggle()
		this.getReasons()
		this.getRows()
	},
}
</script>

<style scoped>
.glove-blue {
	color: #007bff !important;
}
</style>
